import type { FetchBaseQueryError } from '@reduxjs/toolkit/query';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function isRTKApiError(error: any) {
  const fetchError = error as FetchBaseQueryError;
  // See details of FetchBaseQueryError
  const isIgnoredStatus =
    fetchError.status === 'FETCH_ERROR' ||
    fetchError.status === 'TIMEOUT_ERROR';

  if (isIgnoredStatus) return false;

  if (
    ('data' in error &&
      'status' in error &&
      Number.isInteger(error.status) &&
      error.status > 299) ||
    fetchError.status === 'CUSTOM_ERROR' ||
    fetchError.status === 'PARSING_ERROR'
  ) {
    return true;
  }

  return false;
}
